<template>
  <div class="container">
    <p>{{ t('determinePlantCalendarDates') }}</p>
    <hr />
    <div class="row">
      <div class="col-sm">
        <FreeInput
          :input-label="t('plantDate')"
          v-model="startDateStr"
          type="text"
          :unit="isDateValid()"
        />
        <FixedUnitInput
          :input-label="t('daysToSprout')"
          v-model.number="sprout"
          :unit="t('days')"
        />
        <FixedUnitInput
          :input-label="t('daysVegetative')"
          v-model.number="vegetative"
          :unit="t('days')"
        />
        <FixedUnitInput
          :input-label="t('daysFlowering')"
          v-model.number="flowering"
          :unit="t('days')"
        />
        <FixedUnitInput
          :input-label="t('daysDrying')"
          v-model.number="drying"
          :unit="t('days')"
        />
        <FixedUnitInput
          :input-label="t('daysCuring')"
          v-model.number="curing"
          :unit="t('days')"
        />
        <FixedUnitInput
          :input-label="t('daysProcessing')"
          v-model.number="processing"
          :unit="t('days')"
        />
      </div>
      <div class="col-sm">
        <FreeOutput
          :output-label="t('sprouted')"
          :val="sprouted"
        />
        <FreeOutput
          :output-label="t('floweringBegins')"
          :val="floweringBegins"
        />
        <FreeOutput
          :output-label="t('harvest')"
          :val="harvest"
        />
        <FreeOutput
          :output-label="t('doneDrying')"
          :val="doneDrying"
        />
        <FreeOutput
          :output-label="t('doneCuring')"
          :val="doneCuring"
        />
        <FreeOutput
          :output-label="t('doneProcessing')"
          :val="doneProcessing"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { computed, ref, reactive } from 'vue';
  import FreeInput from '../inputs/FreeInput.vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FreeOutput from '../inputs/FreeOutput.vue';
  import dayjs from 'dayjs';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FreeInput,
      FixedUnitInput,
      FreeOutput,
    },
    setup() {
      const startDateStr = ref(dayjs().format("YYYY-MM-DD"));
      const sprout = ref(6);
      const vegetative = ref(28);
      const flowering = ref(49);
      const drying = ref(7);
      const curing = ref(28);
      const processing = ref(0);
      const validDateUnit = ref('');

      const { t } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      
  
      const getFinalDateISO = (addDays) => {
        const original = dayjs(startDateStr.value);
        let adjusted = original.add(addDays, "day");
        return adjusted.toISOString().split("T")[0].substr(0, 10);
      };

    //   watch(startDateStr, (newValue) => {
    //     console.log('startDateStr changed to: ', newValue)
    //     validateDate(newValue);
    //   });

      const isDateValid = () => {

        

            const components = startDateStr.value.split("-");

            if (components.length !== 3) {
                return "❌";
            }

            if (components.some(component => isNaN(component))) {
                return "❌";
            }

            if (components[0].length != 4 || components[1].length != 2 || components[2].length != 2) {
                return "❌";
            }

            if (!dayjs(startDateStr.value).isValid()) {
                return "❌";
            }

            return "✅";

      };
        
        

    //   const validateDate = (date) => {
    //     if (dayjs(date).isValid()) {
    //         console.log('valid date')
    //         validDateUnit.value ='';
    //     }else{
    //         console.log('invalid date')
    //         validDateUnit.value ='Invalid date';
    //     }
    //   };

      const sprouted = computed(() => {
        return getFinalDateISO(sprout.value);
      });

      const floweringBegins = computed(() => {
            return getFinalDateISO(sprout.value + vegetative.value);
       });

        const harvest = computed(() => {
                return getFinalDateISO(sprout.value + vegetative.value + flowering.value);
         });

        const doneDrying = computed(() => {
                return getFinalDateISO(sprout.value + vegetative.value + flowering.value + drying.value);
         });

        const doneCuring = computed(() => {
                return getFinalDateISO(sprout.value + vegetative.value + flowering.value + drying.value + curing.value);
         });

        const doneProcessing = computed(() => {
                return getFinalDateISO(sprout.value + vegetative.value + flowering.value + drying.value + curing.value + processing.value);
         });


  
      return {
        startDateStr,
        sprout,
        vegetative,
        flowering,
        drying,
        curing,
        processing,
        getFinalDateISO,
        sprouted,
        floweringBegins,
        harvest,
        doneDrying,
        doneCuring,
        doneProcessing,
        validDateUnit,
        isDateValid,
        t: translations.t
      };
    },
  };
  </script>
  